import { call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  changeAlertStatusFail,
  changeAlertStatusSuccess,
  changeAlertAssignToUserFail,
  changeAlertAssignToUserSuccess,
  CHANGE_ALERT_STATUS,
  CHANGE_ALERT_ASSIGN_TO_USER,
  fetchAlertDetailsByAlertId,
  fetchAlertDetailsByAlertIdFail,
  fetchAlertDetailsByAlertIdSuccess,
  FETCH_ALERT_DETAILS_BY_ALERT_ID,
  FETCH_WHITELIST_BY_CUSTOMER,
  fetchWhitelistByCustomerSuccess,
  fetchWhitelistByCustomerFail,
  UPDATE_WHITELIST_BY_CUSTOMER,
  updateWhitelistByCustomerSuccess,
  updateWhitelistByCustomerFail
} from '../../redux/actions/cm/alertDetails';
import { reloadCaseDetails } from '../../redux/actions/cm/caseDetails';

import {
  assignAlertsToUser,
  changeAlertStatus,
  fetchAlertDetailsById,
  fetchWhitelistByCustomer as fetchWhitelistByCustomerAPI,
  updateWhitelistByCustomer as updateWhitelistByCustomerAPI
} from '../../services/cm/alerts';

function* fetchAlertDetailsByAlertIdWorker(alertId) {
  try {
    const alertDetails = yield call(fetchAlertDetailsById, alertId);

    yield put(fetchAlertDetailsByAlertIdSuccess(alertDetails));
  } catch (error) {
    yield put(fetchAlertDetailsByAlertIdFail(error.message));
  }
}

export function* watchFecthAlertDetailsByAlertId() {
  yield takeEvery(
    FETCH_ALERT_DETAILS_BY_ALERT_ID,
    function* ({ payload: alertId }) {
      yield fork(fetchAlertDetailsByAlertIdWorker, alertId);
    }
  );
}

function* fetchWhitelistByCustomerWorker(alertId) {
  try {
    const whitelistData = yield call(fetchWhitelistByCustomerAPI, alertId);
    yield put(fetchWhitelistByCustomerSuccess(whitelistData));
  } catch (error) {
    yield put(fetchWhitelistByCustomerFail(error.message));
  }
}

export function* watchFetchWhitelistByCustomer() {
  yield takeEvery(
    FETCH_WHITELIST_BY_CUSTOMER,
    function* ({ payload: alertId }) {
      yield fork(fetchWhitelistByCustomerWorker, alertId);
    }
  );
}

function* updateWhitelistByCustomerWorker(payload) {
  try {
    yield call(updateWhitelistByCustomerAPI, payload);
    yield put(updateWhitelistByCustomerSuccess());
  } catch (error) {
    yield put(updateWhitelistByCustomerFail(error.message));
  }
}

export function* watchUpdateWhitelistByCustomer() {
  yield takeEvery(UPDATE_WHITELIST_BY_CUSTOMER, function* ({ payload }) {
    yield fork(updateWhitelistByCustomerWorker, payload);
  });
}

function* changeAlertStatusWorker({
  alertId,
  status,
  hasAlertActions,
  isCaseAlert
}) {
  try {
    yield call(changeAlertStatus, { alertId, status });
    yield put(changeAlertStatusSuccess());

    if (isCaseAlert) {
      yield put(reloadCaseDetails());
    } else if (hasAlertActions) {
      yield put(fetchAlertDetailsByAlertId(alertId));
    }
  } catch (error) {
    yield put(changeAlertStatusFail(error.message));
  }
}

export function* watchChangeAlertStatus() {
  yield takeEvery(
    CHANGE_ALERT_STATUS,
    function* ({ payload: { alertId, status, hasAlertActions, isCaseAlert } }) {
      yield fork(changeAlertStatusWorker, {
        alertId,
        status,
        hasAlertActions,
        isCaseAlert
      });
    }
  );
}

function* changeAlertAssignToUserWorker({
  alertId,
  userId,
  hasAlertActions,
  isCaseAlert
}) {
  try {
    yield call(assignAlertsToUser, {
      alertIds: [alertId],
      userId
    });
    yield put(changeAlertAssignToUserSuccess());

    if (isCaseAlert) {
      yield put(reloadCaseDetails());
    } else if (hasAlertActions) {
      yield put(fetchAlertDetailsByAlertId(alertId));
    }
  } catch (error) {
    yield put(changeAlertAssignToUserFail(error.message));
  }
}

export function* watchChangeAlertAssignToUser() {
  yield takeEvery(
    CHANGE_ALERT_ASSIGN_TO_USER,
    function* ({ payload: { alertId, userId, hasAlertActions, isCaseAlert } }) {
      yield fork(changeAlertAssignToUserWorker, {
        alertId,
        userId,
        hasAlertActions,
        isCaseAlert
      });
    }
  );
}
